var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "420" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c("v-card-text", [_vm._v(_vm._s(_vm.text))]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: _vm.color || "error" },
                  on: { click: _vm.submit },
                },
                [
                  _vm.icon
                    ? _c("v-icon", [_vm._v(_vm._s(_vm.icon))])
                    : _vm._e(),
                  _vm._v("\n        " + _vm._s(_vm.confirmText) + "\n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary", outline: "" },
                  on: { click: _vm.close },
                },
                [_vm._v(_vm._s(_vm.cancelText))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }